import { useState, useEffect } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useSpeechSynthesisConfig } from '@provider/speech-synthesis';
import { CSSRefTransition } from '@utils/react';
import { toolsTransition, postloadedToolbarTransitionDurationMs, toolbarCls } from './molecule.toolbar.style.js';
import { postloadedModalSelectors } from './organism.content.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { SpeechButton } from '../../speech/speech-button.js';

function Toolbar(props) {
  const speechConfig = useSpeechSynthesisConfig();
  const extraButtons = usePostloadedOption(props.extraButtons);
  const disableToolbar = usePostloadedOption(props.disableToolbar);
  const disableSpeechSynthesisButton = usePostloadedOption(props.disableSpeechSynthesisButton);
  const showToolbar = disableToolbar !== undefined && disableToolbar !== true && !extraButtons?.length;
  const speechSynthesisRootId = `${postloadedModalSelectors.container()}#${props.contentId}`;
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: showToolbar && /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: postloadedToolbarTransitionDurationMs,
      classNames: toolsTransition,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: toolsTransition,
        children: /*#__PURE__*/jsx("div", {
          className: toolbarCls,
          onClick: stopEventPropagation,
          children: /*#__PURE__*/jsxs("ul", {
            children: [extraButtons, speechConfig.enabled && !disableSpeechSynthesisButton && /*#__PURE__*/jsx("li", {
              children: /*#__PURE__*/jsx(SpeechButton, {
                rootSelector: speechSynthesisRootId,
                defaultTooltip: "Læs op",
                hideWhenEmpty: true,
                forceVisibleLangaugeSelector: true
              })
            })]
          })
        })
      })
    })
  });
}
function stopEventPropagation(evt) {
  evt.stopPropagation();
}
function usePostloadedOption(unresolvedContent) {
  const [content, setContent] = useState(unresolvedContent instanceof Promise ? undefined : typeof unresolvedContent === "undefined" ? null : unresolvedContent);
  useEffect(() => {
    if (unresolvedContent instanceof Promise) {
      unresolvedContent.then(speechFile => setContent(speechFile ?? null));
    }
  }, [unresolvedContent]);
  return content;
}

export { Toolbar };
//# sourceMappingURL=molecule.toolbar.js.map
